<template>
<div class="chapter">
<div class="inner_page">
<p class="sink"> </p>
<h1 class="chaptertitle parttitle allcaps">The Seven Sallies of Trurl AND Klapaucius</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c001.vue?7be22bce